import { Copyable } from './Copyable.jsx';

export function PlateNumber({ value, size = 'md', copyable = false, className = '' }) {
  const sizes = {
    sm: 'text-xs px-2 py-0.5',
    md: 'text-sm px-2.5 py-1',
    lg: 'text-lg px-3 py-1.5',
    xl: 'text-3xl px-4 py-2',
  };
  const plateEl = <span className={`plate-number ${sizes[size]} ${className}`}>{value}</span>;
  if (!copyable) return plateEl;
  return (
    <Copyable value={value} as="span" className="hover:brightness-110" title="Click pentru a copia placa">
      {plateEl}
    </Copyable>
  );
}
